module.exports = __webpack_public_path__ + "img/main_technic_3.3f260291.jpg";